import styled from 'styled-components';

export const SplashSectionWrapper = styled.div`
  margin: 0 auto;
  max-width: 1440px;

  padding: 108px 0 108px 0;

  &.jumbotron {
    padding-top: 0;
    padding-bottom: 0;
  }

  @media (max-width: 1500px) {
    padding-left: 36px;
    padding-right: 36px;
  }
  @media (max-width: 710px) {
    padding-top: 64px;
    padding-bottom: 64px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
